import { render } from "./ProductComparisonTableRowHeader.vue?vue&type=template&id=e1864a8e"
import script from "./ProductComparisonTableRowHeader.vue?vue&type=script&lang=js"
export * from "./ProductComparisonTableRowHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__